import { NestedSearch } from "@habity/types";

export const getQueryFromFilters = (filters: Partial<NestedSearch> | null) => {
  const searchParams = new URLSearchParams();

  const {
    longitude,
    latitude,
    living_space_min,
    living_space_max,
    additional_space_min,
    additional_space_max,
    build_year_min,
    build_year_max,
    monthly_fee_min,
    monthly_fee_max,
    rooms_min,
    rooms_max,
    bedrooms_min,
    bedrooms_max,
    plot_size_min,
    plot_size_max,
    price_min,
    price_max,
    categories,
    statuses,
    features,
    nearby,
    places,
    zips,
    streets,
    city,
    label,
    areaIds,
    municipalityIds,
    brokerIds,
    ignore_home_ids,
    officeIds,
    streetIds,
    excludeAssistants,
    requireContainingArea,
  } = filters || {};

  if (longitude) searchParams.append("longitude", longitude.toString());
  if (latitude) searchParams.append("latitude", latitude.toString());
  if (living_space_min)
    searchParams.append("living_space_min", living_space_min.toString());
  if (living_space_max)
    searchParams.append("living_space_max", living_space_max.toString());
  if (additional_space_min)
    searchParams.append(
      "additional_space_min",
      additional_space_min.toString()
    );
  if (additional_space_max)
    searchParams.append(
      "additional_space_max",
      additional_space_max.toString()
    );
  if (monthly_fee_min)
    searchParams.append("monthly_fee_min", monthly_fee_min.toString());
  if (monthly_fee_max)
    searchParams.append("monthly_fee_max", monthly_fee_max.toString());
  if (build_year_min)
    searchParams.append("build_year_min", build_year_min.toString());
  if (build_year_max)
    searchParams.append("build_year_max", build_year_max.toString());
  if (rooms_min) searchParams.append("rooms_min", rooms_min.toString());
  if (rooms_max) searchParams.append("rooms_max", rooms_max.toString());
  if (bedrooms_min)
    searchParams.append("bedrooms_min", bedrooms_min.toString());
  if (bedrooms_max)
    searchParams.append("bedrooms_max", bedrooms_max.toString());
  if (plot_size_min)
    searchParams.append("plot_size_min", plot_size_min.toString());
  if (plot_size_max)
    searchParams.append("plot_size_max", plot_size_max.toString());
  if (price_min) searchParams.append("price_min", price_min.toString());
  if (price_max) searchParams.append("price_max", price_max.toString());
  if (city) searchParams.append("city", city);
  if (label) searchParams.append("label", label);
  // Arrays
  if (categories) categories.map((c) => searchParams.append("categories", c));
  if (statuses) statuses.map((s) => searchParams.append("statuses", s));
  if (features) features.map((f) => searchParams.append("features", f));
  if (nearby) nearby.map((n) => searchParams.append("nearby", n));
  if (places) places.map((p) => searchParams.append("places", p));
  if (zips) zips.map((z) => searchParams.append("zips", z));
  if (streets) streets.map((s) => searchParams.append("streets", s));
  if (areaIds)
    areaIds.map((id) => searchParams.append("areaIds", id.toString()));
  if (municipalityIds)
    municipalityIds.map((id) =>
      searchParams.append("municipalityIds", id.toString())
    );
  if (brokerIds)
    brokerIds.map((id) => searchParams.append("brokerIds", id.toString()));
  if (ignore_home_ids)
    ignore_home_ids.map((id) =>
      searchParams.append("ignore_home_ids", id.toString())
    );
  if (officeIds)
    officeIds.map((id) => searchParams.append("officeIds", id.toString()));
  if (streetIds)
    streetIds.map((id) => searchParams.append("streetIds", id.toString()));
  if (excludeAssistants)
    searchParams.append("excludeAssistants", "true");
  if (requireContainingArea)
    searchParams.append("requireContainingArea", "true");

  return searchParams;
};
